import { render, staticRenderFns } from "./ExternalRecipientCategories.vue?vue&type=template&id=ed887f92&"
import script from "./ExternalRecipientCategories.vue?vue&type=script&lang=js&"
export * from "./ExternalRecipientCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports